type Props = { message: string };

export function Notification({ message }: Props) {
  if (!message) return null;
  return (
    <div className="absolute top-4 left-1/2 -translate-x-1/2 bg-green-500 text-white px-6 py-2 rounded-full shadow-lg z-50 animate-bounce">
      {message}
    </div>
  );
}
